/**
 * Returns true if the value has an explicit definition.
 * @param value
 */
export default function isDefined(value: any) {
  return !!value || value === 0;
}
